import React from "react";
import { Linkedin } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "../../content/ContentContext";

export const Footer = ({ calendlyUrl, linkedinUrl }) => {
  const c = useContent("footer");
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-blush-200/70 bg-white">
      <div className="sc-container py-14 md:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size="md" />
            <p className="sc-body mt-5 max-w-sm">{c.tagline}</p>
          </div>

          <div className="md:col-span-4">
            <p className="sc-eyebrow">Connect</p>
            <ul className="mt-4 space-y-3 font-body text-sm">
              <li>
                <a href={calendlyUrl} target="_blank" rel="noopener noreferrer" className="sc-link" data-testid="footer-calendly-link">
                  Book a 20 minute chat
                </a>
              </li>
              <li>
                <a href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 sc-link" data-testid="footer-linkedin-link">
                  <Linkedin size={14} /> LinkedIn
                </a>
              </li>
              <li><a href="#contact" className="sc-link" data-testid="footer-contact-link">Send a message</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="sc-eyebrow">{c.based_in_label}</p>
            <p className="sc-body mt-4 whitespace-pre-line">{c.based_in}</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-blush-200/60 text-[13px] md:text-[13.5px] text-ink2 font-body leading-[1.7]">
          <p data-testid="acknowledgement-of-country" className="max-w-3xl">{c.acknowledgement}</p>
          <p className="mt-5 flex flex-col sm:flex-row sm:justify-between gap-2 text-muteink">
            <span>© {year} See Chelle. All rights reserved.</span>
            <span className="italic font-serif text-ink/70">{c.signature}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
